module.exports = __webpack_public_path__ + "static/img/historyvideo.199dd987.svg";